/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import { flushSync } from 'react-dom';

export const MORPH_SURFACE = 'mcp-connect-surface';
export const MORPH_TITLE = 'mcp-connect-title';

type ViewTransitionDocument = Document & {
  startViewTransition(update: () => void): { finished: Promise<void> };
};

export const canMorph = (): boolean =>
  typeof document !== 'undefined' &&
  typeof window !== 'undefined' &&
  'startViewTransition' in document &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const morph = (update: () => void): Promise<void> => {
  if (!canMorph()) {
    update();
    return Promise.resolve();
  }
  const transition = (document as ViewTransitionDocument).startViewTransition(() => flushSync(update));
  return transition.finished.catch(() => undefined);
};
